import { KeyboardBackspace } from '@mui/icons-material'
import { Button, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'
import { PatternPageReferrer } from '../../../types/common'

type Props = {
  isEditPage: boolean
}

export default function TopSection(props: Props) {
  const texts = useTranslation('eventPatternPage').t
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <Grid marginY='2rem'>
      <Button 
        variant='text'
        onClick={() => { navigate(-1) }}
        sx={{ marginBottom: '1rem' }}
      >
        <Grid
          container
          alignItems='center'
          gap='.5rem'
        >
          <KeyboardBackspace sx={{ marginTop: '-.125rem' }} />
          {texts(location.state?.referrer === PatternPageReferrer.PATTERN_LIST ? 'back_to_pattern_list' : 'back_to_schedule')}
        </Grid>
      </Button>
      <Grid
        container
        justifyContent='space-between'
        marginBottom='.25rem'
      >
        <Typography variant='h2'>
          {texts(props.isEditPage ? 'edit_title' : 'create_title')}
        </Typography>
      </Grid>
    </Grid>
  )
}